import { ref, watch } from 'vue';

export default ({ searchParams, addSearchParam }) => {
  const sortOptions = {
    MANUAL: 'Featured',
    BEST_SELLING: 'Popularity',
    'CREATED:reverse': "What's new",
    PRICE: 'Price: Low to High',
    'PRICE:reverse': 'Price: High to Low',
  }

  const sortOrderDisplayNames = {
    MANUAL: 'featured',
    BEST_SELLING: 'popularity',
    'CREATED:reverse': 'new',
    PRICE: 'price-ascending',
    'PRICE:reverse': 'price-descending',
  }

  const sortOrder = ref('MANUAL')
  const { 'sort-order': sortOrderArg } = searchParams.value

  if (Object.values(sortOrderDisplayNames).includes(sortOrderArg)) {
    sortOrder.value = Object.fromEntries(
      Object.entries(sortOrderDisplayNames).map(([key, val]) => [val, key])
    )[sortOrderArg]
  }

  watch(sortOrder, () =>
    addSearchParam('sort-order', sortOrderDisplayNames[sortOrder.value])
  )

  return {
    sortOptions,
    sortOrder,
    sortOrderDisplayNames
  }
}